const mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs = {
  mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs: {
    title: 'Descargar PDFs',
    description: 'Vamos a generar un ZIP con los PDFs del período seleccionado. Cuando esté listo, te llegará un correo con el enlace de descarga.',
    filtersDisclaimer: 'El ZIP se generará con los filtros que tenés aplicados en el listado (por ejemplo: estados, puntos de venta, divisa, país, búsqueda, etc.).',
    noInvoicesDisclaimer: 'Si no se encuentran comprobantes con esos filtros, no se enviará el correo.',

    dateFrom: 'Fecha desde',
    dateTo: 'Fecha hasta',
    placeholderDateFrom: 'YYYY-MM-DD',
    placeholderDateTo: 'YYYY-MM-DD',

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'SOLICITAR ZIP',
    buttonPrimaryAgain: 'SOLICITAR OTRO ZIP',
    buttonClose: 'CERRAR',

    success: 'Solicitud enviada. Recibirás un correo electrónico cuando el ZIP esté listo.',
    errorGeneric: 'No se pudo solicitar el ZIP. Espera un momento y vuelve a intentarlo.',

    errorRequiredDates: 'Seleccioná fecha desde y fecha hasta (obligatorias) para poder solicitar el ZIP.',
    errorInvalidDates: 'Las fechas seleccionadas no tienen un formato válido (YYYY-MM-DD).',
    errorDesdeAfterHasta: 'La fecha desde no puede ser mayor que la fecha hasta.',
    errorMaxRange: 'El rango máximo permitido es de 32 días.'
  }
}

export default mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs

